import React, { forwardRef } from 'react';

import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

const SexyButton = forwardRef(({ text, children, ...props }, ref) => {
    return (
        <Button sx={{ color: "var(--tg-theme-text-color)" }} ref={ref} {...props}>
            {text}
            {children}
        </Button>
    );
});

export default SexyButton;